export const FILE_DOWNLOAD_HISTORY_REQUEST = "FILE_DOWNLOAD_HISTORY_REQUEST";
export const FILE_DOWNLOAD_HISTORY_SUCCESS = "FILE_DOWNLOAD_HISTORY_SUCCESS";
export const FILE_DOWNLOAD_HISTORY_FAILURE = "FILE_DOWNLOAD_HISTORY_FAILURE";

export const FILE_DOWNLOAD_UPLOAD_FILE_REQUEST = "FILE_DOWNLOAD_UPLOAD_FILE_REQUEST";
export const FILE_DOWNLOAD_UPLOAD_FILE_SUCCESS = "FILE_DOWNLOAD_UPLOAD_FILE_SUCCESS";
export const FILE_DOWNLOAD_UPLOAD_FILE_FAILURE = "FILE_DOWNLOAD_UPLOAD_FILE_FAILURE";
export const FILE_DOWNLOAD_UPLOAD_FILE_INPROGRESS = "FILE_DOWNLOAD_UPLOAD_FILE_INPROGRESS";
export const FILE_DOWNLOAD_SIZE_LIMIT_EXCEED = "FILE_DOWNLOAD_SIZE_LIMIT_EXCEED";
export const RSU_FILE_INPROGRESS_CHECK = "RSU_FILE_INPROGRESS_CHECK";
export const RESEND_FILE_INPROGRESS_CHECK = "RESEND_FILE_INPROGRESS_CHECK";

export const FILE_DOWNLOAD_RESEND_FILE_REQUEST = "FILE_DOWNLOAD_RESEND_FILE_REQUEST";
export const FILE_DOWNLOAD_RESEND_FILE_SUCCESS = "FILE_DOWNLOAD_RESEND_FILE_SUCCESS";
export const FILE_DOWNLOAD_RESEND_FILE_FAILURE = "FILE_DOWNLOAD_RESEND_FILE_FAILURE";
export const FILE_DOWNLOAD_RESEND_INVALID = "FILE_DOWNLOAD_RESEND_INVALID";
export const NON_RSU_USER_RESEND_INVALID = "NON_RSU_USER_RESEND_INVALID";
export const INVALID_SELECT_MULTIPLE_RSU_FILE = "INVALID_SELECT_MULTIPLE_RSU_FILE";

export const FILE_DOWNLOAD_DELETE_FILE_REQUEST = "FILE_DOWNLOAD_DELETE_FILE_REQUEST";
export const FILE_DOWNLOAD_DELETE_FILE_SUCCESS = "FILE_DOWNLOAD_DELETE_FILE_SUCCESS";
export const FILE_DOWNLOAD_DELETE_FILE_FAILURE = "FILE_DOWNLOAD_DELETE_FILE_FAILURE";

export const FILE_DOWNLOAD_DELETE_ALL_FILES_REQUEST = "FILE_DOWNLOAD_DELETE_ALL_FILES_REQUEST";
export const FILE_DOWNLOAD_DELETE_ALL_FILES_SUCCESS = "FILE_DOWNLOAD_DELETE_ALL_FILES_SUCCESS";
export const FILE_DOWNLOAD_DELETE_ALL_FILES_FAILURE = "FILE_DOWNLOAD_DELETE_ALL_FILES_FAILURE";
export const FILE_DOWNLOAD_DELETE_ALL_FILES_RESET_INIT = "FILE_DOWNLOAD_DELETE_ALL_FILES_RESET_INIT";

export const FILE_DOWNLOAD_DEVICE_STATE_ADD = 'FILE_DOWNLOAD_DEVICE_STATE_ADD';
export const FILE_DOWNLOAD_DEVICE_STATE_REMOVE = 'FILE_DOWNLOAD_DEVICE_STATE_REMOVE';

export const DELETE_RSU_INVALID_CTRL = "DELETE_RSU_INVALID_CTRL";
export const FILE_DOWNLOAD_SERVICE_BUS_UPDATE = "FILE_DOWNLOAD_SERVICE_BUS_UPDATE";
export const FILE_DOWNLOAD_DELETE_MODAL_CTRL = "FILE_DOWNLOAD_DELETE_MODAL_CTRL";
export const FILE_DOWNLOAD_UPLOAD_INPROG_COMPLETE = "FILE_DOWNLOAD_UPLOAD_INPROG_COMPLETE";
export const FILE_DOWNLOAD_RESET_ERRORS = "FILE_DOWNLOAD_RESET_ERRORS";
export const FILE_DOWNLOAD_ERROR_HEADER = "Action Failed";
export const FILE_DOWNLOAD_RETRIEVE_ERROR = "Unable to retrieve files list due to technical error.";
export const FILE_DOWNLOAD_RESEND_ERROR = "Files resend failed due to technical error.";
export const FILE_DOWNLOAD_DELETE_ERROR = "Delete files failed due to technical error.";
export const FILE_DOWNLOAD_UPLOADING_FILE_ERROR = "Unable to upload file due to technical error.";
export const RSU_FILE_INPROGRESS_ERROR = "RSU in progress for this instrument. Kindly initiate new RSU from UI only after existing update is completed.";
export const FILE_DOWNLOAD_SIZE_LIMIT_ERROR = "Send file is blocked as the uncompressed file size exceeds the limit of ";
export const FILE_DOWNLOAD_DELETE_ALL_ERROR = "Delete all failed due to technical error";
export const FILE_DOWNLOAD_RESEND_INVALID_ERROR = "Ensure RSU and Generic files are not selected together to resend to cloud";
export const INVALID_SELECT_MULTIPLE_RSU_FILE_ERROR = "Select one RSU file to resend.";
export const FILE_DOWNLOAD_DELETE_ALL_CONFIRMATION_MESSAGE = "Delete all shall clear the entire Generic files from the list";
export const FILE_DOWNLOAD_DELETE_POPUP_HEADER = "Delete Files";
export const FILE_DOWNLOAD_DELETE_CONFIRMATION_MESSAGE = "The selected files shall be cleared from list grid & Cloud";
export const FILE_DOWNLOAD_DELETE_ALL_ACTION = "deleteall";
export const FILE_DOWNLOAD_DELETE_ACTION = "delete";
export const FILE_DOWNLOAD_DELETE_ALL_ACTION_SUBMITTED = "Delete All Request Submitted Successfully."
export const FILE_TYPE_GENERIC = "Generic";
export const RSU_SERVICE_BUS_MSG_UPDATE = "RSU_SERVICE_BUS_MSG_UPDATE";
export const MESSAGE_TYPE_RSU = "rsustatus";
export const MESSAGE_TYPE_FILE_DWNLD = "filedownloadstatus";
export const FILE_TYPE_RSU = "RSU";
export const RSU_STATUS_INSTL_SCHDLD = "installscheduled";
export const FILE_DOWNLOAD_STATUS_COMPLETED = "Completed";
export const RSU_PACKAGES_RETRIEVE_ERROR = "Unable to retrieve RSU Packages list due to technical error. Please use Add New option to pick the Package.";
export const RSU_DELETE_INVALID_ERROR = "Please ensure RSU packages are not selected to perform delete operation.";
export const DOWNLOAD_FAILED = "downloadfailed";
